import { gql } from '@apollo/client';

import { useDirectoryServiceQuery } from 'src/generated/mloop-graphql';

import DirectoryService from './DirectoryService';
import GoogleDirectoryService from './GoogleDirectoryService';
import MicrosoftCustomDirectoryService from './MicrosoftCustomDirectoryService';
import MicrosoftDirectoryService from './MicrosoftDirectoryService';
import MicrosoftGccHighDirectoryService from './MicrosoftGCCHighDirectoryService';
import MultiDomainDirectoryService from './MultiDomainDirectoryService';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const DirectoryServiceInfoQuery = gql`
  query DirectoryService {
    thisOrg {
      id
      multiDomainEnabled
      integrations {
        id
        google {
          adminUserId
        }
        microsoft {
          active
        }
        microsoftCustom {
          active
          scopes
        }
        microsoftGccHigh {
          active
        }
      }
    }
  }
`;

const useOrgDirectoryService = (): DirectoryService | null => {
  const { data, loading } = useDirectoryServiceQuery();

  if (loading || !data) {
    return null;
  }

  if (data.thisOrg?.multiDomainEnabled) {
    return new MultiDomainDirectoryService();
  }

  const integrations = data.thisOrg?.integrations;

  if (!integrations) {
    return null;
  }

  if (integrations.google) {
    return new GoogleDirectoryService();
  }

  if (integrations.microsoft) {
    return new MicrosoftDirectoryService();
  }

  if (integrations.microsoftCustom) {
    return new MicrosoftCustomDirectoryService(integrations.microsoftCustom.scopes || []);
  }

  if (integrations.microsoftGccHigh) {
    return new MicrosoftGccHighDirectoryService();
  }

  return null;
};

export { useOrgDirectoryService };
